/* Layout */
import Layout from '../../views/layout/Layout.vue'

const StoreList = () => import(/* webpackChunkName: "store" */ '@/views/store/list')
const StoreDetail = () => import(/* webpackChunkName: "store" */ '@/views/store/detail')
const StoreSubscriptionBillingList = () => import(/* webpackChunkName: "store" */ '@/views/store/subscription-billing-list')
const StoreSubscriptionMain = () => import(/* webpackChunkName: "store" */ '@/views/store/subscription/index')
const StoreSubscriptionList = () => import(/* webpackChunkName: "store" */ '@/views/store/subscription/list')
const StoreSubscriptionDetail = () => import(/* webpackChunkName: "store" */ '@/views/store/subscription/detail')

export default [
  {
    path: '/store',
    component: Layout,
    redirect: '/store/list',
    name: 'store',
    alwaysShow: true,
    meta: {
      title: 'store',
      icon: 'store',
    },
    children: [
      {
        path: 'create',
        component: StoreDetail,
        name: 'store-create',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'store',
        },
      },
      {
        path: 'edit/:id',
        component: StoreDetail,
        props: true,
        name: 'store-edit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'store',
        },
      },
      {
        path: 'list',
        component: StoreList,
        name: 'store-list',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'store',
        },
      },
      {
        path: 'subscription-billing/:id',
        component: StoreSubscriptionBillingList,
        props: true,
        name: 'store-subscription-billing-list',
        hidden: true,
        meta: {
          title: 'Subscription Billing List',
          accessibleName: 'store',
        },
      },
      {
        path: 'subscription',
        component: StoreSubscriptionMain,
        redirect: 'noredirect',
        alwaysShow: true,
        name: 'store-subscription-main',
        meta: {
          title: 'Subscription',
          icon: 'list',
          accessibleName: 'store',
        },
        children: [
          {
            path: 'list',
            component: StoreSubscriptionList,
            name: 'store-subscription-list',
            meta: {
              title: 'list',
              icon: 'list',
              accessibleName: 'store',
            },
          },
          {
            path: 'create',
            component: StoreSubscriptionDetail,
            name: 'store-subscription-create',
            // hidden: true,
            meta: {
              title: 'create',
              icon: 'edit',
              accessibleName: 'store',
            },
          },
        ],
      },
    ],
  },
]
